<div class="permit" *transloco="let t; read:'permit'">
    <ng-container *ngIf="currentStep$ | async as currentStep">
        <pmt-select-role *ngIf="currentStep.step === PermitStep.preparationRoleSelection" [permitId]="permitId"></pmt-select-role>

        <pmt-prepare-completed *ngIf="currentStep.step === PermitStep.preparationComplete"></pmt-prepare-completed>

        <pmt-questions *ngIf="currentStep.step === PermitStep.preparationFixedQuestions || currentStep.step === PermitStep.preparationCustomerCheckpoints"
                       [permitId]="permitId" [isPrepare]="true" class="permit__question">
        </pmt-questions>

        <pmt-is-flammable-hotwork
                                  *ngIf="currentStep.step === PermitStep.isFlammableHotWork || currentStep.step === PermitStep.isWorkplaceTemporary"></pmt-is-flammable-hotwork>

        <pmt-workplace *ngIf="currentStep.step === PermitStep.workplace"></pmt-workplace>

        <pmt-emergency-location *ngIf="currentStep.step === PermitStep.emergencyLocation && (fixedTemplate$ | async) as fixedTemplate"
                                [emergencyLocationSettings]="fixedTemplate.emergencyLocation" [permitId]="permitId">
        </pmt-emergency-location>

        <pmt-questions *ngIf="currentStep.step === PermitStep.flammableAtexQuestion"
                       [permitId]="permitId" class="permit__question">
        </pmt-questions>

        <pmt-work-methods *ngIf="currentStep.step === PermitStep.workMethod && (fixedTemplate$ | async) as fixedTemplate"
                          [workMethods]="fixedTemplate.workMethods" [permitId]="permitId">
        </pmt-work-methods>

        <pmt-gasfree-cert *ngIf="currentStep.step === PermitStep.gasFreeCertification"></pmt-gasfree-cert>

        <pmt-questions *ngIf="currentStep.step === PermitStep.fixedQuestions
                           || currentStep.step === PermitStep.customerCheckpoints
                           || currentStep.step === PermitStep.flammableMaterialsFixedQuestions
                           || currentStep.step === PermitStep.flammableMaterialsCustomerCheckpoints
                           || currentStep.step === PermitStep.atexFixedQuestions
                           || currentStep.step === PermitStep.atexCustomerCheckpoints
                           || currentStep.step === PermitStep.gasFreeCertificatesFixedQuestions
                           || currentStep.step === PermitStep.safetyEquipmentFixedQuestions" [permitId]="permitId" class="permit__question">
        </pmt-questions>

        <ng-container *ngIf="workplaceDetails$ | async as premiumPermitSettings; else basePermit">
            <!-- Refactor this. We should only look at the workplace settings before the permit is
                 actually created, or when working with data that's not stored on the permit entity -->
            <ng-container *ngIf="permit$ | async as permit">
                <pmt-photo *ngIf="currentStep.step === PermitStep.preparationPhoto || currentStep.step === PermitStep.photo"
                           [photoRequirement]="permit.photoRequirement">
                </pmt-photo>
                <pmt-permit-additional-information *ngIf="currentStep.step === PermitStep.additionalInformation"></pmt-permit-additional-information>
                <pmt-fire-alarm *ngIf="currentStep.step === PermitStep.fireAlarm" [comment]="premiumPermitSettings.fireAlarmComment"></pmt-fire-alarm>
                <pmt-post-work-monitoring-time *ngIf="currentStep.step === PermitStep.postWorkMonitoringTime" [default]="permit.postWorkMonitoringTime"
                                               [comment]="premiumPermitSettings.postWorkMonitoringComment">
                </pmt-post-work-monitoring-time>
                <pmt-valid-time [default]="premiumPermitSettings.permitDuration < 8 ? premiumPermitSettings.permitDuration : 8"
                                *ngIf="currentStep.step === PermitStep.duration" [comment]="premiumPermitSettings.permitDurationComment"
                                [permitDuration]="premiumPermitSettings.permitDuration"></pmt-valid-time>
            </ng-container>
        </ng-container>

        <ng-template #basePermit>
            <ng-container *ngIf="permit$ | async as permit">
                <pmt-photo *ngIf="currentStep.step === PermitStep.photo" [photoRequirement]="permit.photoRequirement"></pmt-photo>
                <pmt-fire-alarm *ngIf="currentStep.step === PermitStep.fireAlarm"></pmt-fire-alarm>
                <pmt-post-work-monitoring-time *ngIf="currentStep.step === PermitStep.postWorkMonitoringTime" [default]="60"></pmt-post-work-monitoring-time>
                <pmt-valid-time [default]="8" *ngIf="currentStep.step === PermitStep.duration"></pmt-valid-time>
            </ng-container>
        </ng-template>

        <pmt-team *ngIf="currentStep.step === PermitStep.team" [permitId]="permitId"></pmt-team>
        <pmt-signature *ngIf="currentStep.step === PermitStep.signing" [permitId]="permitId"></pmt-signature>
    </ng-container>
</div>

<div class="permit__cta-buttons">
    <button *ngIf="isPhotoButtonVisible()" class="permit__cta-button permit__cta-button--photo" type="button" (click)="openModal('photo')">
        <span *ngIf="(photoCount$ | async) > 0" class="permit__cta-button__bubble" [attr.data-count]="photoCount$ | async">{{ photoCount$ | async }}</span>
    </button>
    <button *ngIf="isCommentButtonVisible()" class="permit__cta-button permit__cta-button--comment" type="button" (click)="openModal('comment')">
        <span *ngIf="(commentCount$ | async) > 0" class="permit__cta-button__bubble"
              [attr.data-count]="commentCount$ | async">{{ commentCount$ | async }}</span>
    </button>
</div>
